import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import { styleMap } from "lit/directives/style-map.js";
import * as storage from "../storage";

@customElement("bible-book-explore-cta")
export class BookExploreCtaElement extends LitElement {
  @property({ attribute: "aria-expanded" })
  ariaExpanded: string = "false";

  private get isDismissed() {
    return storage.get("mobile.cta.dismissed");
  }

  private refs = {
    button: createRef<HTMLButtonElement>(),
  };

  @property({ attribute: "video-thumbnail" })
  videoThumbnail: string = null!;

  createRenderRoot() {
    return this;
  }

  private handleButtonClick() {
    storage.set("mobile.cta.dismissed", true);
    this.dispatchEvent(new CustomEvent("requestopen"));
  }

  private handleDismissButtonClick() {
    storage.set("mobile.cta.dismissed", true);
    this.requestUpdate();
  }

  focus(): void {
    this.refs.button.value?.focus();
  }

  render() {
    // NOTE: if the "BibleBookExploreCta__button" class changes,
    // it needs to be updated in `bible-book-explore.ts`
    return html`
      <div
        class="BibleBookExploreCta"
        style=${styleMap({
          "--image-url": `url(${this.videoThumbnail})`,
        })}
      >
        ${this.isDismissed
          ? null
          : html`<button
              ${ref(this.refs.button)}
              @click=${this.handleDismissButtonClick}
              aria-label="Dismiss"
              class="BibleBookExploreCta__close"
            >
              <svg
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6943 5.71875L11.4131 9L14.6943 12.3125C15.1006 12.6875 15.1006 13.3438 14.6943 13.7188C14.3193 14.125 13.6631 14.125 13.2881 13.7188L10.0068 10.4375L6.69434 13.7188C6.31934 14.125 5.66309 14.125 5.28809 13.7188C4.88184 13.3438 4.88184 12.6875 5.28809 12.3125L8.56934 9L5.28809 5.71875C4.88184 5.34375 4.88184 4.6875 5.28809 4.3125C5.66309 3.90625 6.31934 3.90625 6.69434 4.3125L10.0068 7.59375L13.2881 4.3125C13.6631 3.90625 14.3193 3.90625 14.6943 4.3125C15.1006 4.6875 15.1006 5.34375 14.6943 5.71875Z"
                  fill="white"
                />
              </svg>
            </button>`}
        <button
          @click=${this.handleButtonClick}
          aria-controls="BibleBookExplore"
          aria-expanded=${this.ariaExpanded}
          class="BibleBookExploreCta__button"
        >
          ${this.isDismissed
            ? null
            : html`<span class="BibleBookExploreCta__text"
                >Explore the Bible Visually</span
              >`}
          <span class="BibleBookExploreCta__icon_bp">
            <svg
              width="32"
              height="28"
              viewBox="0 0 32 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M27.9933 3L16.0001 5.25082L4.00684 3V22.9433L8.96685 22.0273V27L16.0263 20.6925L27.9933 22.9433V3Z"
                fill="white"
              />
            </svg>
          </span>
        </button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bible-book-explore-cta": BookExploreCtaElement;
  }
}
